import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { invalidateModelProviders, toConfiguredModelProvider } from "./fetchModelProviders";
const useSaveModelProvider = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const { mutateAsync } = useMutation({
    mutationFn: ({ id, provider, auth, default_model_id }) => (id ? AIConfiguredModelProviders.updateConfiguredProvider(id, { auth, default_model_id }) : AIConfiguredModelProviders.createConfiguredProvider({ provider, auth, default_model_id })).then(toConfiguredModelProvider),
    onSuccess: (_savedProvider, { id, provider }) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_MANAGEMENT.MODEL_PROVIDER_SAVED, {
        app_section: "ai-management-model-providers",
        event_details: { provider }
      });
      UserNotification.success(
        i18n.t(id ? "notifications.model_provider_updated" : "notifications.model_provider_created", {
          ns: "enterprise_ai"
        })
      );
      invalidateModelProviders(queryClient);
    },
    onError: (error, { id }) => UserNotification.error(
      i18n.t(id ? "notifications.update_failed" : "notifications.create_failed", {
        ns: "enterprise_ai",
        message: error.message
      })
    )
  });
  return { saveProvider: mutateAsync };
};
export default useSaveModelProvider;
